import { Component } from '@angular/core';

@Component({
  selector: 'cx-reset-new-password',
  templateUrl: './reset-new-password-page.component.html',
  styles: ['./reset-new-password-page.component']
})
export class ResetNewPasswordComponent {}
